import jinjaToJS from "jinja-to-js";export default function templateModulesProductFeedOosSectionHeader(ctx) {
    var __result = "";
    var __tmp;
    var __runtime = jinjaToJS.runtime;
    var __filters = jinjaToJS.filters;
    var __globals = jinjaToJS.globals;
    var context = jinjaToJS.createContext(ctx);
    __result += "<div class=\"product-feed__oos-header\">\n    <h3 class=\"product-feed__oos-header__title\">Out of Stock</h3>\n</div>";
    return __result;
}